  <script>
  export default {
    name: 'SecretToken',
    props: {
      value: {
        type: String,
        default: ''
      },
      isVerified: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        editing: false,
        tempToken: this.value
      };
    },
    computed: {
      token() {
        return this.value;
      },
      tokenHidden() {
        return this.token ? '****' + this.token.slice(-4) : '';
      }
    },
    methods: {
      startEditing() {
        this.tempToken = this.token;
        this.editing = true;
      },
      cancelEditing() {
        this.editing = false;
        this.tempToken = this.token;
      },
      saveToken() {
        this.$emit('input', this.tempToken);
        this.editing = false;
      },
      verifyToken() {
        this.$emit('verify', this.tempToken);
      },
    }
  };
  </script>

<template lang="pug">
    .secret-token
      div(v-if="!editing")
        b-input-group
          b-form-input(v-model="tokenHidden", :disabled="true")
          b-input-group-append
            b-button(@click="startEditing")
              i.la.la-pencil
            b-button(v-if="token", @click="verifyToken", :class="{'btn-primary': !isVerified, 'btn-success': isVerified}") {{ isVerified ? 'Verified' : 'Verify' }}
            //b-button.btn-secondary(v-if="token && verifying && !isVerified", disabled)
              i.la.la-spinner.la-spin
      div(v-else)      
        b-input-group
          b-form-input(type="text", v-model="tempToken", placeholder="Enter secret token")
          b-input-group-append            
            b-button.btn-secondary(@click="cancelEditing") Cancel
            b-button.btn-primary(@click="saveToken") Save
</template>   

  